import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'

import {
  IconeSetaAvancar,
  Botao,
  IconeSetaDuplaRetornar,
  FormUnform,
  IconeDoAvatarDoUsuario,
  FormRef,
  Carregando,
  AutenticacaoContainer,
  ComentarioTopicoArquivoInput,
  Tooltip,
  Informacao,
  ConteudoBotao,
  IconeAdicionar
} from 'src/componentes'
import { CHAVE_AVATAR_ALUNO } from 'src/componentes/barra-superior-layout/providers/barra-superior.provider'
import { EditorUnform } from 'src/componentes/unform/editor'
import { sanitizeUtil } from 'src/componentes/utils'
import { InfoPrivado } from 'src/paginas/sala-aula/outros-cursos/grupo-discussao/topico/styles'
import { Api } from 'src/servicos'
import * as Storage from 'src/servicos/local-storage'
import { TipoGrupoDiscussao, Topico as TopicoType } from 'src/tipos/'

import { ContainerIncluir, Botao as BotaoIcone } from '../../../styles'
import { Comentario } from './comentario'
import { ModalEditarTextoApoio } from './modal-editar-texto-apoio'
import { ModalEditarTextoApoioRef } from './modal-editar-texto-apoio/tipos'
import { schema } from './schema'
import {
  Container,
  ContainerBotao,
  Conteudo,
  ImagemUsuario,
  ListaComentarios,
  SubtituloTopico,
  TituloTopico
} from './styles'
import { TopicoProps } from './tipos'

const avatar = Storage.obter(CHAVE_AVATAR_ALUNO) as { foto: string }

export const Topico: React.FC<TopicoProps> = ({
  onClick,
  idTopico,
  idGrupoDiscussao,
  tipoGrupoDiscussao
}) => {
  const formRef = useRef<FormRef>(null)
  const [topico, definirTopico] = useState({} as TopicoType)
  const [carregandoTopico, definirCarregandoTopico] = useState(false)
  const [carregando, definirCarregando] = useState(false)
  const { usuario } = AutenticacaoContainer.useContainer()
  const tipoTCC = tipoGrupoDiscussao === TipoGrupoDiscussao.TCC
  const modalRef = useRef<ModalEditarTextoApoioRef>(null)

  const dica = {
    dicaId: '1',
    dicaInfo:
      'Sua resposta é privada, somente você e o aluno conseguem visualizar.'
  }

  const ehUsuarioCriador = useMemo(() => {
    return usuario.id === topico?.usuarioId
  }, [usuario, topico])

  const comentariosBloqueados = useMemo(() => {
    return topico?.comentariosBloqueados ?? false
  }, [topico])

  const carregarTopico = useCallback(async () => {
    try {
      definirCarregandoTopico(true)
      const resposta = await Api.RequisitarTopicoPorId(idTopico)

      definirTopico(resposta)
    } catch {
      definirTopico(null)
    } finally {
      definirCarregandoTopico(false)
    }
  }, [idTopico])

  const acaoSucesso = async (payload: {
    comentario: string
    privado: boolean
    arquivo?: File | string
  }) => {
    try {
      definirCarregando(true)

      await Api.CriarComentario(
        idGrupoDiscussao,
        idTopico,
        sanitizeUtil(payload.comentario),
        payload.privado ?? false,
        payload.arquivo
      )

      formRef.current?.clearField('comentario')
      formRef.current?.clearField('arquivo')
      await carregarTopico()
    } finally {
      definirCarregando(false)
    }
  }

  useEffect(() => {
    carregarTopico()
  }, [carregarTopico])
  return (
    <>
      <Container>
        <TituloTopico>
          <h3>Fórum de dúvidas</h3>
          {IconeSetaAvancar}
          <span>{topico.titulo}</span>
        </TituloTopico>
        {topico.textoApoio && (
          <SubtituloTopico
            dangerouslySetInnerHTML={{ __html: topico.textoApoio }}
          />
        )}
        <Botao
          elemento={<>{IconeSetaDuplaRetornar} Voltar para os tópicos</>}
          elementoInvertido
          tema="Link"
          onClick={onClick}
        />
        <ContainerIncluir>
          <BotaoIcone
            type="button"
            onClick={() => modalRef.current?.abrir(topico?.topicoId)}
          >
            <ConteudoBotao>
              {IconeAdicionar} {topico?.textoApoio ? 'Editar' : 'Incluir'} Texto
              de Apoio
            </ConteudoBotao>
          </BotaoIcone>
        </ContainerIncluir>
      </Container>

      {carregandoTopico ? (
        <Carregando texto="Carregando comentários ..." />
      ) : (
        <ListaComentarios>
          {topico && topico?.comentarios && (
            <Comentario
              tipo="comentario"
              comentarios={topico?.comentarios}
              topico={topico?.topicoId}
              grupo={idGrupoDiscussao}
              tipoGrupoDiscussao={tipoGrupoDiscussao}
              carregarTopico={carregarTopico}
            />
          )}
        </ListaComentarios>
      )}

      {(ehUsuarioCriador || !comentariosBloqueados) && (
        <FormUnform ref={formRef} acaoSucesso={acaoSucesso} schema={schema}>
          <>
            <Conteudo>
              <ImagemUsuario>
                {avatar && avatar.foto ? (
                  <img width="40" height="40" src={avatar.foto} />
                ) : (
                  IconeDoAvatarDoUsuario
                )}
              </ImagemUsuario>
              <EditorUnform
                id="comentario"
                name="comentario"
                label="Adicionar um comentário"
                placeholder="Digite sua mensagem aqui..."
              />
            </Conteudo>

            <ContainerBotao>
              <ComentarioTopicoArquivoInput id="arquivo" name="arquivo" />

              {!tipoTCC && (
                <InfoPrivado data-tip={dica.dicaInfo} data-for={dica.dicaId}>
                  <Informacao />
                  <Tooltip id={dica.dicaId} place={'right'} html={true} />
                </InfoPrivado>
              )}

              <Botao
                texto={tipoTCC ? 'Enviar Mensagem' : 'Enviar Comentário'}
                carregando={carregando}
                type="button"
                onClick={() => formRef?.current?.submitForm()}
              />
            </ContainerBotao>
          </>
        </FormUnform>
      )}
      <ModalEditarTextoApoio
        backdrop
        ref={modalRef}
        acaoSucesso={carregarTopico}
      />
    </>
  )
}
